module.exports = __webpack_public_path__ + "media/images/markup-images/noukaweb-logo-16x9-699e1c96f76225c892fcc9d11972b1b0.jpg";